import { Activite } from './activite.model';

export class Cours {
    idcours: string;
    designation: string;
    datedebut: Date;
    datefin: Date;
    nombreplace: number;
    resarecquis: boolean;
    datecreation: Date;
    activite: Activite;
    participants: number;
    

}


// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/model/cours.model.ts